import React from 'react'
import styled from 'styled-components'
import { Outlet } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Header from 'components/landing-page/Header'
import Footer from 'components/landing-page/Footer'

const FullHeightGrid = styled(Grid)`
  min-height: 100vh;
`

const MarketingPageLayout = () => (
  <Container maxWidth="xl">
    <FullHeightGrid container direction="column" justifyContent="space-between">
      <Grid item component="header">
        <Header />
      </Grid>

      <Grid item>
        <Outlet />
      </Grid>

      <Grid item component="footer">
        <Footer />
      </Grid>
    </FullHeightGrid>
  </Container>
)

export default MarketingPageLayout
